import React from 'react'
import Layout from '../components/Layout'
import Head from 'next/head'
import { FeatureBySection } from '../components/FeatureBySection'
import { WhatToExpectSection } from '../components/BecomeATechnicianPage/WhatToExpectSection'
import { ApplyNowSection } from '../components/BecomeATechnicianPage/ApplyNowSection'
import { BecomeTechnicianTitleSection } from '../components/BecomeTechnicianTitleSection'

const BecomeATechnicianPage: React.FC = () => {
  return (
    <Layout showGetQuote={false} title={'Become A Technician | Join The NuBrakes Team | NuBrakes Mobile Brake Repair'}>
      <Head>
        <meta
          name={'description'}
          content={
            'Join NuBrakes as we redefine the brake repair industry. If you’re an experienced mechanic looking for competitive pay and a sense of freedom, apply to become a NuBrakes mobile brake tech today.'
          }
        />
      </Head>
      <BecomeTechnicianTitleSection
        title={'Join the NuBrakes Team'}
        subheading={'NuBrakes is hiring full-time and part-time technicians'}
        buttonText={'Apply Now'}
      />
      <FeatureBySection />
      <WhatToExpectSection />
      {/*<WhatDoOurTechsHaveToSaySection/>*/}
      <ApplyNowSection />
    </Layout>
  )
}

export default BecomeATechnicianPage
